import { useState } from 'react';

import { batchAnalyzeSessions, type BatchAnalyzeResponse } from '../services/api/sessions';

const BATCH_LIMIT = 20;

export const formatBatchSummary = ({
  analyzed,
  requested,
  failed,
  qualityCounts,
}: BatchAnalyzeResponse): string => {
  const failedPart = failed > 0 ? ` (${failed} misslyckades)` : '';
  const insufficientPart =
    qualityCounts.insufficient > 0 ? ` · ${qualityCounts.insufficient} utan underlag` : '';

  return `Analyserade ${analyzed}/${requested}${failedPart} — ${qualityCounts.poor} dåliga · ${qualityCounts.degraded} försämrade · ${qualityCounts.good} goda${insufficientPart}`;
};

type BatchStatus = {
  loading: boolean;
  message: string | null;
  isError: boolean;
};

const IDLE: BatchStatus = { loading: false, message: null, isError: false };

export const useBatchAnalyze = ({ onDone }: { onDone: () => Promise<unknown> }) => {
  const [status, setStatus] = useState<BatchStatus>(IDLE);

  const run = async (days: number) => {
    setStatus({ loading: true, message: null, isError: false });

    try {
      const result = await batchAnalyzeSessions({
        days,
        limit: BATCH_LIMIT,
        onlyUnanalyzed: true,
      });
      setStatus({ loading: false, message: formatBatchSummary(result), isError: false });
      await onDone();
    } catch (error) {
      setStatus({
        loading: false,
        message: error instanceof Error ? error.message : 'Batch-analys misslyckades',
        isError: true,
      });
    }
  };

  return { status, run, limit: BATCH_LIMIT };
};
